import * as Sentry from '@sentry/react'

export const initSentry = () => {
  const dsn =
    process.env.REACT_APP_SENTRY_DSN ||
    'https://fc81ee6f22f54843ad96906d28c3bf1b@errors.rtitech.io/6'

  if (dsn) {
    Sentry.init({
      dsn,
      environment: 'production',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      tracesSampleRate: 0.01,
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 0.01
    })
  }
}

export default Sentry
